import React from "react";
import { TASK_LABEL } from "./taskCopy";
import { founderReadinessFromRoadmapItem } from "./founderRoadmapCopy";

function RoadmapSprintGroup({ group, items, onOpenTask }) {
  if (!group) return null;
  const children = (group.roadmapItemIds || [])
    .map((id) => items.find((item) => item.id === id))
    .filter(Boolean);

  return (
    <section className="roadmap-sprint-group" data-testid={`roadmap-sprint-group-${group.id}`}>
      <header>
        <h3>Sprint on Roadmap</h3>
        <p>
          Version {group.sprintVersion} · {group.lane === "next" ? "Next" : "Now"}
        </p>
      </header>
      {children.length === 0 ? (
        <p>No linked {TASK_LABEL}s in this sprint group.</p>
      ) : (
        <ul>
          {children.map((item) => (
            <li key={item.id} data-testid={`roadmap-sprint-child-${item.id}`}>
              <strong>{item.title}</strong>
              <span>{liveChildStatus(item)}</span>
              {item.workBriefId && onOpenTask ? (
                <button
                  type="button"
                  className="secondary-button"
                  onClick={() => onOpenTask(item.workBriefId)}
                  data-testid={`roadmap-sprint-open-${item.id}`}
                >
                  Open {TASK_LABEL}
                </button>
              ) : null}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export function liveChildStatus(item) {
  const readiness = founderReadinessFromRoadmapItem(item);
  if (readiness.code === "readiness_unknown" && item?.linkedAcceptanceReview) {
    return "In review";
  }
  return readiness.label;
}

export default RoadmapSprintGroup;
